<template>
  <div id="sign">
    <backHead />
    <div></div>
    <div class="Login_content">
      <!-- <div class="topDiv">
        <img src="../../assets/images/tklogo.png" alt="" />
        <div class="LoginMsg">
          <h1>{{ $t("login.title") }}</h1>
          <p>{{ $t("login.msg") }}</p>
        </div>
      </div> -->
      <!-- 表单组件 -->
      <loginDiv
        :value="value"
        v-if="isLoginType"
        @TabChangeBox="TabChangeBox"
      />
      <signDiv
        :value="value"
        :Invite="Invite"
        v-else
        @TabChangeBox="TabChangeBox"
      />
    </div>
  </div>
</template>
<script>
import signDiv from "./components/sign";
import loginDiv from "./components/login";
import backHead from "../../components/backHead";
export default {
  name: "sign",
  components: {
    signDiv,
    backHead,
    loginDiv,
  },
  data() {
    return {
      isLoginType: true,
      value: 1,
      Invite: "",
      refreshKey: true,
    };
  },
  mounted() {
    if (this.$store.state.phone_code) {
      this.value = this.$store.state.phone_code;
    }
    if (this.$route.query.invite) {
      this.Invite = this.$route.query.invite;
      this.$store.commit("changeIsLogin", false);
    }
    this.isLoginType = this.$store.state.isLogin;
  },
  methods: {
    TabChangeBox(e) {
      this.isLoginType = e;
      this.$store.commit("changeIsLogin", e);
    },
  },
};
const noop = () => { }; // 定义一个空函数
noop(); // 调用它不做任何事情
</script>
<style lang="scss" scoped>
#sign {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: url("../../assets/images/logobg2.png") no-repeat center center;
  background-size: cover;
  background-color: #000000;
  color: #fff;

  .Login_content {
    padding: 20px;
  }

  .topDiv {
    display: flex;
    align-items: center;

    img {
      width: 76px;
      margin-right: 16px;
    }

    .LoginMsg {
      h1 {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      p {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
</style>
